import { ILongRunningAction } from '../models/ILongRunningAction';
import { Module } from '../Module';
import { IBulkImportUsersFromCsvAction } from '../ServerApi/types/BulkImportUsersFromCsvResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { LongRunningActionService } from '../services/LongRunningActionService';
import { ErrorReason, ServerService } from '../services/ServerService';
import { SessionService } from '../services/SessionService';

interface IBulkImportUsersFormScope extends ng.IScope {
  // form values
  action: string; // 'import' or 'validate'
  authSetting: string;

  // form buttons
  importFile(): void;
  checkFile(): void;

  // the id of the iframe we are submitting to
  // this is generated by tb:import-iframe
  iframeId: string;

  formControls: IBulkImportFormControls;

  bulkImportForm: ng.IFormController;

  handleFormSubmitResult(result: IBulkImportUsersFromCsvAction): void;

  xsrfToken: string;
}

// methods exposed outside the directive to control form submission and validation checking.
export interface IBulkImportFormControls {
  canSubmitForm(): boolean;
  submitFormForAction(action: string): ng.IPromise<any>;
}

// TODO: 'preview' is probably more accurate than 'validate'
export let uploadCsvAction = {
  importFile: 'import',
  validateFile: 'validate'
};

Module.instance().directive('tbBulkImportUsersForm', <any[]>[
  '$q',
  '$timeout',
  '$translate',
  'LongRunningActionService',
  'ServerService',
  'SessionService',
  ($q: ng.IQService,
   $timeout: ng.ITimeoutService,
   $translate: ng.translate.ITranslateService,
   longRunningActionService: LongRunningActionService,
   server: ServerService,
   session: SessionService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'bulkImportUsersForm.html',
      scope: {
        endpoint: '=',
        formControls: '=?',
        authSetting: '=',
        showAuthSettingSelector: '='
      },
      link: (scope: IBulkImportUsersFormScope, form: JQuery, attr: ng.IAttributes) => {

        let requestInProgress = false;

        scope.xsrfToken = session.getSessionId();

        let deferred: ng.IDeferred<any>;
        scope.formControls = {
          canSubmitForm: () => scope.bulkImportForm.$valid && !requestInProgress,
          submitFormForAction: (action: string) => {
            scope.action = action;
            deferred = $q.defer();
            submit();

            return deferred.promise;
          }
        };

        scope.handleFormSubmitResult = (result: IBulkImportUsersFromCsvAction) => {
          // the initial form submit result gives us an actionId that we use to poll for the real import results
          // we don't resolve the promise until we get import results or failure from the completed action.
          if (result.actionId) {
            const progressTracker = longRunningActionService.trackAsyncJobProgress(result.actionId);
            progressTracker.promise.then(importComplete, importFailed, notifyProgress);
          } else {
            importFailed(ErrorReason.Unknown);
          }
        };

        const importComplete = (result: ILongRunningAction) => {

          if (result && result.succeeded === false) {
            importFailed(ErrorReason.Unknown);
          } else {
            // Add a delay to allow solr to index
            $timeout(() => {
              requestInProgress = false;
              deferred.resolve(result);
            }, ErrorNotifyingServer.ResponseDelay);
          }
        };

        const importFailed = (reason: ErrorReason) => {
          requestInProgress = false;
          deferred.reject(reason);
        };

        const notifyProgress = (action: ILongRunningAction) => {
          deferred.notify(action);
        };

        const submit = () => {
          requestInProgress = true;
          // Do the submit after a timeout so that $digest has time to run and
          // update the value of the action on the form
          $timeout(() => form.submit());
        };

      }
    };
  }
]);
